export default "__VITE_ASSET__Dca1X2Y8__"